export function objectToArray(obj: Object): Array<Object> {
  if (!obj) { return null; }
  const keys = Object.keys(obj);
  const res = [];
  for (let i = 0; i < keys.length; i++) {
      res[i] = { key: keys[i], value: obj[keys[i]] };
  }
  return res;
}

export function toStringByKey(key: string, data: Array<any>, separator: string = ','): string {
  let i: number;
  let res: string;

  res = '';
  for (i = 0; i < data.length; i++) {
      const value = data[i][key].replace('&', '&amp;');
      if (!res) {
          res = value;
      } else {
          res += separator + value;
      }

  }

  return res;
}


export function deepClone(object: object): object {
    return JSON.parse(JSON.stringify(object));
}


export function buildArrayByKey(key: string, data: Array<any>): Array<any> {
  let i: number;
  const res_arr: Array<any> = [];
  let val: any;


  for (i = 0; i < data.length; i++) {
      val = data[i][key];
      if (!res_arr[val]) {
          res_arr[val] = [];
      }
      res_arr[val].push(data[i]);

  }


  return res_arr;
}

export function indexOfArrayByKey(key: string, value: any, data: Array<any>): number {
  let i: number = 0;

  while (data && (i < data.length)) {
      if (value == data[i][key] || value == Number(data[i][key])) {
          return i;
      }

      i++;
  }

  return -1;
}

export function newFromJson<T>(json: string, Type: { new(Object): T }): T | T[] {
  try {
      if (!json) { return null; }
      const parsed = JSON.parse(json);
      if (parsed instanceof Array) {
          return parsed.map(u => new Type(u));
      }
      return new Type(parsed);
  } catch (e) { console.error(`Error parsing JSON array to ${Type.name}.`); }
  return null;
}
